import { buildSceneInstanceRecords } from './sceneInstanceIdentity'

const cleanText = (value) => String(value ?? '').trim()

export const getSceneObjectBaseId = (modelPath) => {
    const value = cleanText(modelPath)
    if (!value) return ''
    return value.includes('__') ? value.split('__')[0] : value
}

export const getSceneObjectCopySegments = (modelPath) => {
    const value = cleanText(modelPath)
    if (!value || !value.includes('__')) return []

    return value
        .split('__')
        .slice(1)
        .map((part) => cleanText(part))
        .filter((part) => /^\d+$/.test(part))
}

export const getSceneObjectCopySuffix = (modelPath) => {
    const segments = getSceneObjectCopySegments(modelPath)
    return segments.length ? `_${segments.join('_')}` : ''
}

export const formatSceneObjectDisplayName = (
    baseName,
    modelPath,
    { fallback = 'Модель', includeCopySuffix = true } = {}
) => {
    const base = cleanText(baseName) || cleanText(fallback) || 'Модель'
    if (!includeCopySuffix) return base
    return `${base}${getSceneObjectCopySuffix(modelPath)}`
}

export const resolveSceneObjectBaseName = ({
    baseName = '',
    customObject = null,
    product = null,
    meta = null,
    modelData = null,
    cartItem = null,
    fallback = 'Модель',
} = {}) => {
    if (customObject) {
        if (customObject?.kind === 'text') {
            const text = cleanText(customObject?.textData?.text)
            if (text) return `Текст: ${text}`
        }

        return cleanText(customObject?.name)
            || cleanText(customObject?.customName)
            || cleanText(customObject?.shapeLabel)
            || 'Деталь'
    }

    const calc = cartItem?.calculatorData || {}

    return cleanText(baseName)
        || cleanText(product?.fullName)
        || cleanText(meta?.fullName)
        || cleanText(modelData?.fullName)
        || cleanText(product?.name)
        || cleanText(meta?.name)
        || cleanText(modelData?.name)
        || cleanText(calc?.baseModelName)
        || cleanText(cartItem?.fullName)
        || cleanText(cartItem?.name)
        || cleanText(product?.article)
        || cleanText(meta?.article)
        || cleanText(modelData?.article)
        || cleanText(fallback)
        || 'Модель'
}

export const resolveSceneObjectDisplayName = ({
    modelPath = '',
    baseName = '',
    customObject = null,
    product = null,
    meta = null,
    modelData = null,
    cartItem = null,
    fallback = 'Модель',
} = {}) => {
    const resolvedBaseName = resolveSceneObjectBaseName({
        baseName,
        customObject,
        product,
        meta,
        modelData,
        cartItem,
        fallback,
    })

    return formatSceneObjectDisplayName(resolvedBaseName, modelPath, {
        fallback,
        includeCopySuffix: !customObject,
    })
}

export const buildSceneObjectIdentityIndex = (
    selectedModels = {},
    instanceIds = {},
    copyPaths = {}
) => {
    const records = buildSceneInstanceRecords(selectedModels, instanceIds, copyPaths)
    const byPath = {}
    const byCategoryIndex = {}
    const byInstanceId = {}

    records.forEach((record) => {
        if (record?.path) byPath[record.path] = record
        if (record?.instanceId) byInstanceId[record.instanceId] = record
        if (record?.categoryKey !== undefined && record?.categoryKey !== null) {
            byCategoryIndex[`${record.categoryKey}:${record.index}`] = record
        }
    })

    return {
        records,
        byPath,
        byCategoryIndex,
        byInstanceId,
    }
}

export const getSceneObjectRecordAt = (
    selectedModels = {},
    instanceIds = {},
    copyPaths = {},
    categoryKey,
    index = 0
) => (
    buildSceneObjectIdentityIndex(selectedModels, instanceIds, copyPaths)
        .byCategoryIndex[`${categoryKey}:${index}`] || null
)
